import React from 'react';
import PropTypes from 'prop-types';
// import outdoorLogo from '../../img/outdoor-logo';
import SafeHTML from './SafeHTML';
import ImageBlock from './ImageBlock';
import customPropTypes from '../utils/customPropTypes';
import style from 'scss/components/Footer';
import moment from 'moment';
import GenericNavList from './MainNavigation/GenericNavList';
import logo from '../../img/hunterlab-white.png';
import qrBottom from '../../img/QR_Bottom.png';
import LangLogo from '../../img/globe.svg';

export default class Footer extends React.Component {

  static propTypes = {
    heading: PropTypes.string,
    contact_phone: PropTypes.string,
    contact_address: PropTypes.string,
    instagram_link: PropTypes.string,
    facebook_link: PropTypes.string,
    linkedin_link: PropTypes.string,
    twitter_link: PropTypes.string,
    privacyPolicy: PropTypes.string,
    termsOfUse: PropTypes.string,
    certifications: PropTypes.string,
    sitemap: PropTypes.string,
  }

  static defaultProps = {
    address: '',
    city: '',
    state: '',
    zip: '',
  }
  year = moment().format('YYYY')
  getImageProp = () => {
    let img = {};
    img.url = logo;
    img.title = this.props.heading;
    return img;
  }



  getLangImageProp = () => {
    let img = {};
    img.url = LangLogo;
    return img;
  }


  togglelangMenu_Spanish(){
      location.href = "https://www.hunterlab.com/es"+window.location.pathname;
  }

  togglelangMenu_English() {
    location.href = "https://www.hunterlab.com/en"+window.location.pathname;
  }

  togglelangMenu_UKEnglish() {
    location.href = "https://www.hunterlab.com/en-uk"+window.location.pathname;
  }

  render() {
    return (
      <footer className="footer">
        <section className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col footer-contact-info">
                <div className="hunterlab-info">
                  <h1><ImageBlock image={this.getImageProp()} imgClassName="object-embed" addWrapper={false} width="180px"></ImageBlock>
                  </h1>
                  <div className="footer-addr">
                    <div>
                      <div className="footw"><span><p><SafeHTML>{this.props.contact_address}</SafeHTML></p></span></div>
                      </div>
                    </div>
                  <aside className="social-links">
                    <h4 className="social-links-title">联系我们</h4>
                    <a href={this.props.instagram_link} target="_blank" className="icon icon-instagram" />
                    <a href={this.props.linkedin_link} target="_blank" className="icon icon-linkedin" />
                    <a href={this.props.facebook_link} target="_blank" className="icon icon-facebook" />
                    <a href={this.props.twitter_link} target="_blank" className="icon icon-twitter" />
                  </aside>
                </div>
              </div>
              <div className="col footer-top-menu">
              <GenericNavList
                footer="footer-link"
                  items={this.props.mainMenuItems} showDesc={false}>
                  <ul className="footer-ul">
                    <li className="footer-links">
                      <a href="https://support.hunterlab.com/">客户支援</a>
                    </li>
                    <li className="footer-links">
                      <a href="https://blog.hunterlab.com/blog/">博客</a>
                    </li>
                    <li className="footer-links">
                      <a href={this.props.contact_page_url}>联系我们</a>
                    </li>
                  </ul>
                  
                  <li className="qr-code">
                      <div className="footw"></div>
                      <div className="img-stylee">
                        <div className="qrnav-footer">
                          <div className="img-nav"></div>
                          <div className="img-title">微信号</div>
                          <div className="qrhover-footer"><img src={qrBottom} alt="" width="200px" /></div>
                          </div>
                      </div>
                  </li>
                </GenericNavList>
              </div>
            </div>
            <div className='lang-footer'>
                <ImageBlock image={this.getLangImageProp()} addWrapper={false}></ImageBlock>
                <a href="#" onClick={() => this.togglelangMenu_English()}className='lang-link'>English</a>
                <a href='https://www.hunterlab.de' className='lang-link'>Deutsch</a>
                <a href="#" onClick={() => this.togglelangMenu_Spanish()} className='lang-link'><span>Spanish</span></a>
                <a href="#" onClick={() => this.togglelangMenu_UKEnglish()} className='lang-link'><span>UK English</span></a>
              </div>
          </div>
        </section>
        <section className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col">
                <span>&copy; {this.year} Hunter Associates Laboratory, Inc.</span>
              </div>
              <div className="col">
                <ul className="menu">
                  <li><a href={this.props.certifications}>资质证书</a></li>
                  <li><a href={this.props.termsOfUse}>使用条款</a></li>
                  <li><a href={this.props.privacyPolicy}>隐私政策</a></li>
                  <li><a href={this.props.sitemap}>网站地图</a></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </footer>

    )
  }

}
